import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function Entry(props) {
  return (
    <div className="column col-md-4 single-service">
    <div className="services-container" style={{marginRight: "10px"}}>
      <div>
  		  <div className="item-service">
           <div  className="item-service-icon">
              <FontAwesomeIcon className="service-icons changeOn" size="3x" icon={props.icon} />
           </div>
           <div className="item-service-content">
              <h5 style={{fontWeight:"bold"}}>{props.name}</h5>
              <p>{props.description}</p>
           </div>
        </div>
      </div>
  	</div>
    </div>
  );
}

export default Entry;
